/* jslint esversion: 6 */
/**
 * Menu Focus Aria
 *
 * @author Dylan James Wagner
 */
function init() {
  events();
}

function events() {
  document.querySelectorAll('.menu-item-has-children:not(.menu__item--has-toggle)').forEach(element => {
    element.addEventListener('focusin', event => { toggleARIAExpanded(event, element) });
    element.addEventListener('focusout', event => { toggleARIAExpanded(event, element) });
  });
}

function toggleARIAExpanded(event, element) {

  if (element.getAttribute('aria-expanded') === 'true') {
    element.setAttribute('aria-expanded', 'false');
  }
  else {
    element.setAttribute('aria-expanded', 'true');
  }
}

export {init as default};
